export const endpoints = {
  ui: 'case/ui'
};
